import {withJsonFormsControlProps} from '@jsonforms/react';
import ToggleButtonControl from './ToggleButtonControl';
export default withJsonFormsControlProps(ToggleButtonControl);
